import {groupBy} from "lodash";
import {SEARCH_TYPES} from "./typefactories";

const SOLR_SPECIAL_CHARS = /([+\-&|!(){}[\]^~*?:\\/])/g;

export function groupTerms(searchTerms) {
    const group = groupBy(searchTerms, it => it.type);

    group[SEARCH_TYPES.TERM] = group[SEARCH_TYPES.TERM] || [];
    group[SEARCH_TYPES.ADV_TERM] = group[SEARCH_TYPES.ADV_TERM] || [];
    group[SEARCH_TYPES.FILTER] = group[SEARCH_TYPES.FILTER] || [];
    group[SEARCH_TYPES.RANGE_YEAR_FILTER] = group[SEARCH_TYPES.RANGE_YEAR_FILTER] || [];
    group[SEARCH_TYPES.FUND_FILTER] = group[SEARCH_TYPES.FUND_FILTER] || [];

    return group;
}

export function buildQuery(terms, advTerms) {
    if (!terms.length && !advTerms.length)
        return "*:*";

    let termsStr = terms.length
        ? `_text_:(${terms.map(it => it.value.replace(SOLR_SPECIAL_CHARS, "\\$1")).join(' ')})`
        : '';
    let advTermsStr = advTerms.length
        ? advTerms.map(it => `${it.field}:${it.value.replace(SOLR_SPECIAL_CHARS, "\\$1")}`).join(" AND ")
        : '';

    return [termsStr, advTermsStr].filter(it => it.length > 0).join(" AND ")
}

export function removeIf(valuesToTest, listToFilter, tests) {
    for (const test of tests) {
        if (valuesToTest.some(test))
            listToFilter = listToFilter.filter(it => !test(it))
    }

    return listToFilter;
}
